/* template */
<template><div class="mpx-root-view"><div class="main"><div class="content-item"><JourneySite :style='["width: 100%"] | transRpxStyle' :selectCityList="(selectCityList)" @exchange="exchange" @click="goPage"/></div><mpx-view @tap.stop="onTravelCalendarShow" class="content-item content-item-train-date"><div class="content-item-date">{{ selectDateText1 }}</div><div class="content-item-week">{{ selectDateText2 }}</div></mpx-view><es-checkbox-group :value="checkboxValue" mpxModelEvent="input" @mpxModel='__model("checkboxValue", $event, ["value"], undefined)' direction="row" :style='["justify-content:space-between;"] | transRpxStyle'><es-checkbox v-for="(item, index) in (condition)" :key="item['{{item.value}}']" :name="(item.value)" label-position="right" nameIcon="check-filled" shap="square" :iconSize="(12)" :fontSize="(18)" :icon-style="({borderRadius: '4px', height: '12px', width: '12px'})" @change="onChange(item.value)" class="content-checkbox"><span class="es-rm-checkbox">{{ item.name }}</span></es-checkbox></es-checkbox-group><mpx-view @tap="notice" class="es-rm-rule" v-if="(checkboxValue.includes('student'))">学生购票须知</mpx-view><mpx-view @tap="search" class="card-button-area"><div :style="[(btnStyle)] | transRpxStyle" class="card-button">查询车票</div><BubbleBtn :bubbleText="(bubbleText)" class="bubble-btn"/></mpx-view><SearchHistory :historyList="(historyList)" v-if="(!isAliAndNotLogin)"/></div><es-popup :value="travelCalendarVisible" mpxModelEvent="input" @mpxModel='__model("travelCalendarVisible", $event, ["value"], undefined)' position="bottom" :closeable="(true)"><es-calendar ref="calendar" type="single" :showConfirm="(false)" :value="selectDateValue" mpxModelEvent="input" @mpxModel='__model("selectDateValue", $event, ["value"], undefined)' :maxDate="(limitDate.maxDateForReserve)" :minDate="(limitDate.minDate)" @confirm="onConfirm"/></es-popup></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m77e2731e"}'>
@import '~@/mixins/stylus/color.styl'

.main
  background #fff
  border-radius 16px
  overflow hidden
  padding 0 16px 16px
  .content-item
    display flex
    justify-content space-between
    align-items center
    height 66px
    width 100%
    font-size 16px
    color $train-color-333
    border-bottom 0.5px solid $train-color-eee
  .content-item-train-date
    line-height 53px
    justify-content flex-start
    height 53px
    align-items baseline
    .content-item-date
      font-weight 600
      font-size 18px
      font-family PingFangSC-Regular, Helvetica, Arial, sans-serif
    .content-item-week
      font-weight 500
      font-size 13px
      margin-left 4px
  .content-checkbox
    height 47px
    display flex
    align-items center
    user-select none
    overflow hidden
    .es-checkbox .es-checkbox__icon
      border-radius 4px !important
  .es-rm-checkbox
    font-weight 400
    font-size 13px
    color $train-color-666
    margin-left -4px
  .es-rm-rule
    font-size 11px
    color #FF6400
    margin-left 6px
    position relative
    top -31px
    left 55px
    height 0
  .card-button-area
    position relative
    .card-button
      height 50px
      line-height 50px
      font-size 16px
      text-align center
      color white
      border-width 0px
      border-radius 12px
      font-weight 600
    .bubble-btn
      position absolute
      top -10px
      right 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m77e2731e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex77e2731e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex77e2731e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m77e2731e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index77e2731e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'BubbleBtn':getComponent(require("../bubble-btn/index.mpx?isComponent&outputPath=components%2Findexd2aa2f48%2Findex")),'JourneySite':getComponent(require("../journey-site/index.mpx?isComponent&outputPath=components%2Findex514292f5%2Findex")),'es-calendar':getComponent(require("../../../../components/calendar/index.mpx?isComponent&outputPath=components%2Findex2f88bd1e%2Findex")),'es-checkbox-group':getComponent(require("../../../../es-mpx-ui/lib/checkbox-group/index.mpx?isComponent&outputPath=components%2Findex5f7ef460%2Findex")),'es-checkbox':getComponent(require("../../../../es-mpx-ui/lib/checkbox/index.mpx?isComponent&outputPath=components%2Findex8e1a7e44%2Findex")),'SearchHistory':getComponent(require("../search-history/index.mpx?isComponent&outputPath=components%2Findex2fc6ffb0%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
